import React from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import renderHtml from 'helpers/renderHtml';
import LightningIcon from 'assets/icons/daily/icon-park-twotone_lightning.svg?react';
import FireIcon from 'assets/icons/daily/fluent-emoji-flat_fire.svg?react';
import CoinIcon from 'assets/icons/daily/coin.svg?react';

const ContentText = styled(Typography)(({ theme }) => ({
  marginBottom: 20,
  position: 'relative',
  '& svg': {
    position: 'absolute',
    top: 0,
    left: -40,
    [theme.breakpoints.down('sm')]: {
      left: -35
    }
  }
}));

const DialogStyles = styled(Dialog)(() => ({}));

const DialogContentTitle = styled(Typography)(({ theme }) => ({
  fontSize: 21,
  fontFamily: 'Unbounded',
  marginBottom: 58,
  [theme.breakpoints.down('sm')]: {
    marginBottom: 30
  }
}));

const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  padding: 53,
  paddingLeft: 100,
  paddingRight: 100,
  [theme.breakpoints.down('sm')]: {
    padding: 20,
    paddingLeft: 50
  }
}));

const ResourcesInfo = ({ open, onClose }) => {
  const t = useTranslate('Profile');

  return (
    <DialogStyles open={open} fullWidth={true} maxWidth="md" scroll="body" onClose={onClose}>
      <DialogContentStyled>
        <DialogContentTitle>{t('QuestInfo')}</DialogContentTitle>
        <ContentText>
          <CoinIcon />
          {renderHtml(t('QuestInfoContent'))}
        </ContentText>
        <ContentText>{renderHtml(t('QuestInfoContent1'))}</ContentText>
        <ContentText>{renderHtml(t('QuestInfoContent2'))}</ContentText>

        <ContentText>
          <LightningIcon />
          {renderHtml(t('QuestInfoContent3'))}
        </ContentText>
        <ContentText>{renderHtml(t('QuestInfoContent4'))}</ContentText>

        <ContentText>
          <FireIcon />
          {renderHtml(t('QuestInfoContent5'))}
        </ContentText>
      </DialogContentStyled>
    </DialogStyles>
  );
};

export default ResourcesInfo;
